







































import { Component, Vue, Prop } from 'vue-property-decorator'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import IconWarningTriangle from '@/app/ui/assets/icon_warning_triangles.vue'

@Component({
  inheritAttrs: false,
  components: {
    TextInput,
    IconWarningTriangle
  },
})
export default class OrderTextInput extends Vue {
  @Prop({ type: String }) private title!: string
  @Prop({ type: String }) private errorMessage!: string
  @Prop({ type: Boolean, default: false }) private isUppercase!: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object }) private vuelidateObject!: Record<string, any>

  private handleInput(e: string) {
    if (this.isUppercase) e = e.toUpperCase()
    this.$emit('input', e)

    if (this.vuelidateObject) this.vuelidateObject.$touch()
  }

  get hasError(): boolean {
    return (
      this.vuelidateObject &&
      this.vuelidateObject.$invalid &&
      this.vuelidateObject.$dirty
    )
  }
}
